import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=4d376da3&scoped=true&"
import script from "./CategoryItem.vue?vue&type=script&lang=ts&"
export * from "./CategoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryItem.vue?vue&type=style&index=0&id=4d376da3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d376da3",
  null
  
)

export default component.exports